import ShippingCityPostcode from './shippingCityAndPostcode';

export default ShippingCityPostcode;